import { gql } from '../../../../hooks'

export const CHANGE_PASSWORD = gql`
  mutation ProfileChangePassword($password: String!, $new_password: String!) {
    pChangePassword(password: $password, new_password: $new_password) {
    }
  }
`
